var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7.33366H14.6668V13.3337C14.6668 13.5105 14.5966 13.68 14.4716 13.8051C14.3465 13.9301 14.177 14.0003 14.0002 14.0003H2.00016C1.82335 14.0003 1.65378 13.9301 1.52876 13.8051C1.40373 13.68 1.3335 13.5105 1.3335 13.3337V7.33366ZM11.3335 2.00033H14.0002C14.177 2.00033 14.3465 2.07056 14.4716 2.19559C14.5966 2.32061 14.6668 2.49018 14.6668 2.66699V6.00033H1.3335V2.66699C1.3335 2.49018 1.40373 2.32061 1.52876 2.19559C1.65378 2.07056 1.82335 2.00033 2.00016 2.00033H4.66683V0.666992H6.00016V2.00033H10.0002V0.666992H11.3335V2.00033Z",
    fill: "url(#paint0_linear_20523_107425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20523_107425",
    x1: 2.19624,
    y1: 0.666992,
    x2: 17.873,
    y2: 17.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9360A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B7E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGradient);
export default __webpack_public_path__ + "static/media/calendarGradient.4b9e41d290d94da0199361036166952b.svg";
export { ForwardRef as ReactComponent };